import * as preact from 'preact'
const { h, Component } = preact
import * as style from './style.css'
import PureComponent from '../../../../lib/preact-pure-component'
import classNames from 'classnames'
import { LinkData } from '../index'
import { connect } from '../../../../../lib/provider'

interface Props {
  linkData: LinkData
}

interface ConnectedProps {
  sendGaEvent: (evt: Object) => void
}

class _Link extends PureComponent<Props & ConnectedProps, {}> {
  click = (e, url: string) => {
    e.preventDefault()
    this.props.sendGaEvent({ action: 'linkOut', label: url })
    setTimeout(() => {
      document.location = url
    }, 50)
  }

  render() {
    const { image, linkData } = this.props

    return (
      <a className={style.link} href={linkData.href} onClick={e => this.click(e, linkData.href)}>
        <img src={image} className={style.image} alt="" />

        <span
          className={style.linkText}
          onClick={e => this.click(e, linkData.href)}
          href={linkData.href}
          dangerouslySetInnerHTML={{ __html: linkData.text }}
        />
      </a>
    )
  }
}

const connector = connect()
export const Link = connector(_Link)
